import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-website-drop-down-filter',
  templateUrl: './website-drop-down-filter.component.html'
})
export class WebsiteDropDownFilterComponent implements OnInit {

  @Input() identifier
  @Input() module
  @Output() selectEmmiter = new EventEmitter()
  @Input() currentUserSelect = 'All articles'

  constructor() { }

  ngOnInit(): void {
  }

}
